import { atom, useAtom } from 'jotai';

export const redirectUserAtom = atom<boolean>(true);

export const useUserRedirect = () => {
  const [canRedirectUser, handleUserRedirect] = useAtom(redirectUserAtom);

  return { canRedirectUser, handleUserRedirect };
};
